import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7dca617e")

_pushScopeId("data-v-7dca617e")
const _hoisted_1 = {
  key: 0,
  class: "flex flex-col text-lg"
}
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = {
  key: 0,
  class: "my-0 text-xs"
}
const _hoisted_4 = {
  key: 1,
  class: "flex justify-end"
}
const _hoisted_5 = {
  key: 0,
  class: "text-red-700 text-center"
}
const _hoisted_6 = { class: "flex items-center flex-col pt-6" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_QuestionNext = _resolveComponent("QuestionNext")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
      return (_openBlock(), _createBlock("div", {
        key: option.label,
        onClick: () => _ctx.onClick(option.value),
        class: `flex text-primary cursor-pointer bg-white items-center p-5 border-solid border-2 rounded-xl w-full justify-between ${
      _ctx.currentAnswer.indexOf(option.value) > -1
        ? 'border-accent'
        : 'border-secondary'
    }`
      }, [
        (option.label)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                _createVNode("div", {
                  class: `checkbox-icon ${
            _ctx.currentAnswer.indexOf(option.value) > -1 && 'checkbox-active'
          }`
                }, [
                  _createVNode(_component_CheckIcon)
                ], 2),
                _createVNode("div", null, [
                  _createVNode("span", {
                    innerHTML: option.label
                  }, null, 8, ["innerHTML"]),
                  (option.subtitle)
                    ? (_openBlock(), _createBlock("p", _hoisted_3, [
                        _createVNode("span", {
                          innerHTML: option.subtitle
                        }, null, 8, ["innerHTML"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (option.image)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("img", {
                src: option.image,
                alt: option.label || '',
                class: "flex image"
              }, null, 8, ["src", "alt"])
            ]))
          : _createCommentVNode("", true)
      ], 10, ["onClick"]))
    }), 128)),
    (_ctx.errorMessage)
      ? (_openBlock(), _createBlock("p", _hoisted_5, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_QuestionNext, { onNext: _ctx.onNext }, null, 8, ["onNext"])
    ])
  ], 64))
})